export const yesNoUnsureOptions = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
  { value: "unsure", label: "Unsure" },
];

export const primaryReasonForStudyingOptions = [
  { value: "study", label: "To undertake full-time study in my chosen course" },
  { value: "work", label: "To work in Australia" },
  { value: "migratePermanently", label: "To migrate permanently" },
  { value: "joinFamily", label: "To join family or friends" },
  { value: "other", label: "Other" },
];

export const estimatedAnnualLivingCostOptions = [
  { value: "less_than_20000", label: "Less than AUD 20,000" },
  { value: "20000_24000", label: "AUD 20,000 - 24,000" },
  { value: "24505_or_more", label: "AUD 24,505 or more" },
  { value: "not_sure", label: "Not sure" },
];

export const fundingSourceOptions = [
  { value: "personal_savings", label: "Personal savings" },
  { value: "family_support", label: "Family financial support" },
  { value: "education_loan", label: "Education loan" },
  { value: "scholarship", label: "Scholarship or sponsor" },
  { value: "not_arranged", label: "Not yet arranged" },
];

export const workStudyExpectationOptions = [
  {
    value: "work_within_limits",
    label: "I may work within visa limits to supplement my funds",
  },
  {
    value: "do_not_intend_to_work",
    label: "I do not intend to work while studying",
  },
  {
    value: "rely_on_work_income",
    label: "I expect to rely on work income to cover my main expenses",
  },
];
